import { render, staticRenderFns } from "./curriculum_teacher.vue?vue&type=template&id=1b7cb320&"
import script from "./curriculum_teacher.vue?vue&type=script&lang=js&"
export * from "./curriculum_teacher.vue?vue&type=script&lang=js&"
import style0 from "./curriculum_teacher.vue?vue&type=style&index=0&id=1b7cb320&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports